import {
  createFeatureAppDefinition,
  useSpaNavigation,
} from '@smart/feature-app/react';
import {RouterProvider} from '@smart/react-components';
import React from 'react';
import App from './components/app';

export default createFeatureAppDefinition({
  App: ({done}) => {
    const navigate = useSpaNavigation();
    return (
      <RouterProvider navigate={navigate}>
        <App done={done} />
      </RouterProvider>
    );
  },
});
